const state = {
  dataCallHistory: [],
  dataCallHistoryCTI: [],
  dataCallHistorySecondaryCTI: []
}

const getters = {
  dataCallHistory (state) {
    return state.dataCallHistory
  },
  dataCallHistoryCTI (state) {
    return state.dataCallHistoryCTI
  },
  dataCallHistorySecondaryCTI (state) {
    return state.dataCallHistorySecondaryCTI
  }
}

const mutations = {
  SET_DATA_CALL_HISTORY (state, dataCallHistory) {
    state.dataCallHistory = dataCallHistory
  },
  SET_DATA_CALL_HISTORY_CTI (state, dataCallHistory) {
    state.dataCallHistoryCTI = dataCallHistory
  },
  SET_DATA_CALL_HISTORY_SECONDARY_CTI (state, dataCallHistory) {
    state.dataCallHistorySecondaryCTI = dataCallHistory
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
